import {
  EXCEPTION_NOTIFICATION,
  CONTACT_INFORMATION_TITLE,
  STREET_ADDRESS,
  SPACER,
  CITY,
  POSTAL_CODE,
  EXCEPTION_NOTIFICATIONS_TITLE,
  OPEN_HOURS,
  EXCEPTION_SCHEDULES,
  SERVICES_CONTACT_INFORMATION_TITLE,
  SERVICES_CONTACT_INFORMATION,
  SHOW_SCHEDULES_LINK,
  TICKET_SALES_LINK,
  THEATER_SERVICES,
  OPEN_HOURS_AND_PRICE_INFO_TITLE,
  PROPERTIES_TITLE,
  DESCRIPTION,
  DESCRIPTION_TITLE
 } from '../elements.template'

const LAYOUT = {
  type: 'theater',
  layout: [
    [
      // Start left column
      DESCRIPTION_TITLE,
      DESCRIPTION,
      OPEN_HOURS_AND_PRICE_INFO_TITLE,
      { ...OPEN_HOURS, hideLabel: false },
      EXCEPTION_SCHEDULES,
      { ...SHOW_SCHEDULES_LINK, style: { flex: 1, maxWidth: '38rem' } },
      { ...TICKET_SALES_LINK, style: { flex: 1, maxWidth: '38rem' } },
      PROPERTIES_TITLE,
      { ...THEATER_SERVICES, hideLabel: true }
      // End left column
    ],
    [
      // Start right column
      SERVICES_CONTACT_INFORMATION_TITLE,
      SERVICES_CONTACT_INFORMATION,
      EXCEPTION_NOTIFICATIONS_TITLE,
      { ...EXCEPTION_NOTIFICATION, hideLabel: true, style: { paddingTop: '0.375rem' } },
      CONTACT_INFORMATION_TITLE,
      {
        type: 'container',
        className: 'customRowFixed',
        style: { paddingBottom: '10rem' },
        items: [
          STREET_ADDRESS,
          SPACER,
          CITY,
          SPACER,
          POSTAL_CODE
        ]
      }
      // End right column
    ]
  ]
}

export default LAYOUT
